customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('collection-subnav-carousel')) return;

  class CollectionSubnavCarousel extends SliderComponent {
    constructor() {
      super();
      this._layoutRefreshRaf = null;
      queueMicrotask(() => this.refreshLayout());
    }

    connectedCallback() {
      this.refreshLayout();
      this._onSectionLoad = (event) => {
        if (event.target.contains(this)) this.refreshLayout();
      };
      document.addEventListener('shopify:section:load', this._onSectionLoad);
    }

    disconnectedCallback() {
      if (this._onSectionLoad) {
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
      }
      if (this._layoutRefreshRaf) cancelAnimationFrame(this._layoutRefreshRaf);
    }

    refreshLayout() {
      if (this._layoutRefreshRaf) cancelAnimationFrame(this._layoutRefreshRaf);

      this._layoutRefreshRaf = requestAnimationFrame(() => {
        this._layoutRefreshRaf = requestAnimationFrame(() => {
          this._layoutRefreshRaf = null;
          if (typeof this.resetPages === 'function') this.resetPages();
          this.updateArrowVisibility();
        });
      });
    }

    update() {
      super.update();

      if (!this.slider || !this.nextButton) return;

      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

      if (this.slider.scrollLeft <= 1) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.slider.scrollLeft >= maxScroll - 1) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      this.updateArrowVisibility();
    }

    onButtonClick(event) {
      event.preventDefault();

      if (!this.slider || !this.sliderItemOffset) return;

      const step = Number(event.currentTarget.dataset.step || 1);
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

      if (event.currentTarget.name === 'next') {
        const nextPosition = this.slider.scrollLeft + step * this.sliderItemOffset;
        const lastSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];

        if (!lastSlide) {
          this.setSlidePosition(Math.min(nextPosition, maxScroll));
          return;
        }

        const lastSlideEnd = lastSlide.offsetLeft + lastSlide.clientWidth;

        if (nextPosition + this.slider.clientWidth >= lastSlideEnd - 1) {
          this.setSlidePosition(maxScroll);
        } else {
          this.setSlidePosition(Math.min(nextPosition, maxScroll));
        }
      } else {
        const prevPosition = this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(Math.max(0, prevPosition));
      }
    }

    updateArrowVisibility() {
      if (!this.slider) return;

      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const hasScroll = maxScroll > 1;

      this.classList.toggle('is-scrollable', hasScroll);
      this.classList.toggle('is-at-start', this.slider.scrollLeft <= 1);
      this.classList.toggle('is-at-end', this.slider.scrollLeft >= maxScroll - 1);
    }
  }

  customElements.define('collection-subnav-carousel', CollectionSubnavCarousel);
});
